module.exports = __webpack_public_path__ + "static/media/cctv_poster.366c0477.png";